import HonorsInfoForm from './HonorsInfoForm';

export default HonorsInfoForm;
